"use client";

import { useEffect, useState } from "react";

type UseElementVisibleProps = {
	id: string;
};

export const useElementPresent = ({ id }: UseElementVisibleProps) => {
	const [isElementVisible, setIsElementVisible] = useState(false);

	useEffect(() => {
		let currentIsElementVisible = false;

		const syncElementVisibility = () => {
			const nextIsElementVisible = Boolean(document.getElementById(id));

			if (currentIsElementVisible === nextIsElementVisible) {
				return;
			}

			currentIsElementVisible = nextIsElementVisible;
			setIsElementVisible(nextIsElementVisible);
		};

		syncElementVisibility();

		const observer = new MutationObserver(syncElementVisibility);
		observer.observe(document.body, { childList: true, subtree: true });

		return () => observer.disconnect();
	}, [id]);

	return { isElementVisible };
};
